import React, {
    useEffect,
} from "react";
import {useDispatch, useSelector} from 'react-redux';

import { Link } from "react-router-dom";

import {
    Select,
    List,
    Button,
    Skeleton,
    Divider
} from 'antd';

import * as T from 'utils/types';
import {altTrendingThunks} from "./AltTrendingTabSlice";
import Error500 from "components/errors/Error500";
import "./AltmetricBadge.css"
import searchPgUserInputsS from 'features/content/search_page/UserInputsSlice';

const {Option} = Select;

// publication tab
export default () => {
    const dispatch = useDispatch();


    useEffect(() => {
        // _altmetric_embed_init is offered by Altmetric in embeded.js file
        // this func will let js to find new altmetric-embed div and fetch the data for them
        // eslint-disable-next-line
        eval('if(typeof _altmetric_embed_init!="undefined"){_altmetric_embed_init();}');
    })

    const {
        facultyID,
        departmentID,
        searchTab,
        altTrendingSpecific: { sortType }
    } = useSelector((state: T.RootState) => state.searchPgUserInputs);

    const {
        status,
        hasNext,
        pubList,
    } = useSelector((state: T.RootState) => state.altTrendingTab);



    useEffect(()=>{
        searchTab === T.SearchTab.TRENDING && dispatch(altTrendingThunks.initList({
            facultyID, departmentID,
            sortType
        }));
    }, [
        facultyID, departmentID,
        sortType, dispatch, searchTab,
    ]);

    const sortTypeOptions : {tag: string, value: T.altTrendingSortType}[] = [
        {
            tag: "Altmetric Attention Score",
            value: "-altmetric_score"
        },
        {
            tag: "Mentions in the past day",
            value: "-historical_mentions_1d"
        },
        {
            tag: "Mentions in the past three days",
            value: "-historical_mentions_3d"
        },
        {
            tag: "Mentions in the past week",
            value: "-historical_mentions_1w"
        },
        {
            tag: "Mentions in the past month",
            value: "-historical_mentions_1m"
        },
        {
            tag: "Mentions in the past three months",
            value: "-historical_mentions_3m"
        },
        {
            tag: "Mentions in the past six months",
            value: "-historical_mentions_6m"
        },
        {
            tag: "Total mentions",
            value: "-historical_mentions_at"
        },
    ];

    return <>

        <span className="sub-heading-font">
            <strong>Sort by:</strong>
        </span> <Select
            className="sub-heading-font"
            value={sortType}
            style={{width:300}}
            onChange={ value => {
                dispatch(searchPgUserInputsS.actions.setAltTrendingSortType(value));
            }}
            filterOption={(input, option) => (option !== undefined) && 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            { sortTypeOptions.map( x => 
                <Option className="sub-heading-font" value={x.value} key={x.value}>
                    {x.tag}
                </Option>
            )}
        </Select>

        {status!=="failed"&&<List
            loading={status==="idle"}
            itemLayout="horizontal"
            loadMore={
                hasNext ? <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button
                        className="sub-heading-font"
                        onClick={() => dispatch(altTrendingThunks.loadMore())}
                    >
                        More
                    </Button>
                </div> : null
            }
            dataSource={pubList}
            renderItem={ item => {
                const pub = item.item as T.AltTrendingItem;
                return <List.Item>
                    <Skeleton avatar title={false} loading={item.loading} active>
                        {pub&&<List.Item.Meta

                            avatar={<div
                                    className='altmetric-embed'
                                    data-badge-type='donut'
                                    data-badge-popover="right"
                                    data-link-target='_blank'
                                    data-altmetric-id={pub?.altmetric_id||"0"}
                                ></div>}

                            title = {<a 
                                    className="sfu-red-link"
                                    href={ pub.doi==null ? pub.altmetric_url : `https://doi.org/${pub.doi}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {pub.title}
                                </a>}

                            // xxx != null equals to xxx !== undefined && xxx !== null
                            description={<>
                                {pub.journal_title != null && <>
                                    <span>
                                        <strong><em>{pub.journal_title}</em></strong>
                                    </span> 
                                    <br/> 
                                </>}

                                {pub.publication_date && <>
                                    <span>
                                        <strong>Publication Date:</strong> {pub.publication_date}
                                    </span>
                                    <br/>
                                </>}

                                {pub.sfu_authors.length>0 && <>
                                    <span>
                                        <strong>SFU faculty authors</strong>: {pub.sfu_authors.map(
                                            (author, index) => (
                                                <React.Fragment key={index}>
                                                    <Link to={`/profile/${author.random_id}`}>
                                                        <span className='gray-link-button'>
                                                            {author.preferred_last_name}{author.preferred_first_name && `, ${author.preferred_first_name[0]}.`}
                                                        </span>
                                                    </Link>
                                                    {index !== pub.sfu_authors.length - 1 &&
                                                    <Divider type='vertical' style={{margin: '0 0.3em'}}/>}
                                                </React.Fragment>
                                            )
                                        )}
                                    </span>
                                    <br/>
                                </>}

                                {
                                    sortType!=="-altmetric_score" &&
                                    sortType!=="-historical_mentions_at" &&
                                    (pub as any)[sortType.slice(1)] != null && <>
                                    <span>
                                        <strong> &#x25a0; {(pub as any)[sortType.slice(1)]} </strong> 
                                        mentions in the past {{
                                            "-historical_mentions_1d":"day", 
                                            "-historical_mentions_3d":"three days", 
                                            "-historical_mentions_1w":"week", 
                                            "-historical_mentions_1m":"month", 
                                            "-historical_mentions_3m":"three months", 
                                            "-historical_mentions_6m":"six months", 
                                            "-historical_mentions_1y":"year" 
                                        }[sortType]}
                                    </span>
                                    <br/>
                                </>}

                                {pub.historical_mentions_at != null && <>
                                    <span>
                                        <strong> &#x25a0; {pub.historical_mentions_at} </strong> 
                                        total mentions
                                    </span>
                                    <br/>
                                </>}

                                

                            </> }
                        />}
                    </Skeleton>
                </List.Item>;
            } }
        />}
        
        { status==="failed"&&<Error500/> }




    </>;
}